import * as React from "react";
import { BaseTable } from "../../../base/components/BaseTable";
import { LoginOutlined } from "@ant-design/icons/lib";
import { Button } from "antd";
import { useStoreActions, useStoreState } from "../../../../store/hooks";
import { Group, User } from "../../../auth/models";
import { getItemsSelector } from "../../../normalized/selectors/getItemsSelector";
import { t } from "../../../../translation";
import { getAuthenticatedPath } from "../../../../shared/routes";
import { useHistory } from "react-router-dom";

export const HijackUserTable: React.FC = () => {
    const hijackLoginAction = useStoreActions(
        (actions) => actions.auth.hijackLogin
    );
    const groups: Group[] = useStoreState((state) =>
        getItemsSelector(state, "groups")
    );
    const history = useHistory();

    return (
        <>
            <BaseTable<User>
                subState="users"
                title={t("users.tableTitle")}
                filtersInUrl={true}
                extraColumnData={{ groups }}
                onCreate={() => {
                    history.push(getAuthenticatedPath("users-new"));
                }}
                onEdit={(user) => {
                    history.push(
                        getAuthenticatedPath("users-detail", { id: user.id })
                    );
                }}
                extraColumns={[
                    {
                        align: "right",
                        width: "50px",
                        render: (record: any) => (
                            <Button
                                type="default"
                                shape="circle"
                                onClick={() => {
                                    hijackLoginAction({
                                        userId: record.key,
                                    }).then(() => window.location.reload());
                                }}
                                icon={<LoginOutlined />}
                            />
                        ),
                    },
                ]}
            />
        </>
    );
};
